<template>
    <a-card>
        <div id="whatsapp-wizard">
            <a-steps v-model="current" type="navigation" :style="stepStyle">
                <a-step :status="getStatus(0)" :title="$t('wp.agreement')" :disabled="current !== 0" />
                <!-- <a-step :status="getStatus(1)" :title="$t('wp.purchase')" :disabled="current !== 1" /> -->
                <a-step :status="getStatus(2)" :title="$t('wp.activating')" :disabled="current !== 2" />
                <a-step :status="getStatus(3)" :title="$t('wp.authenticating')" :disabled="current !== 3" />
                <a-step :status="getStatus(4)" :title="$t('wp.ready')" :disabled="current !== 4" />
            </a-steps>

            <div class="d-flex justify-content-center">
                <div v-if="current === 0" class="step step0">
                    <Agreement @agree="agree" />
                </div>
                <!-- <div v-if="current === 1" class="step step1">
                    <Purchase :purchase-completed="purchaseCompleted" />
                </div> -->
                <div v-if="current === 2" class="step step2">
                    <Activation :activated="activationCompleted" />
                </div>
                <div v-if="current === 3" class="step step3">
                    <QRCodeAuthentication />
                </div>
                <div v-if="current === 4" class="step step4">
                    <WPStatusViewer />
                </div>
            </div>
        </div>
    </a-card>
</template>

<script>
import "./wp.scss";
import Agreement from "./Agreement";
import Purchase from "./Purchase";
import Activation from "./Activation";
import QRCodeAuthentication from "./QRCodeAuthentication";
import WPStatusViewer from "./WPStatusViewer";
import { sendSocketMessage } from "../../utils/socketStream";
import { mapMutations, mapState } from "vuex";
import log2 from "../../utils/log2";
import CONFIG from "../../config/config";

const log = log2("WhatsappWizard");
const LSTATES = CONFIG.WHATSAPP.LAUNCH_STATES;
export default {
    name: "WhatsappWizard",
    components: {
        Agreement,
        Purchase,
        Activation,
        QRCodeAuthentication,
        WPStatusViewer,
    },
    data() {
        return {
            current: 0,
            stepStyle: {
                marginBottom: "60px",
                boxShadow: "0px -1px 0 0 #e8e8e8 inset",
            },
            waiting: false,
            agreementAccepted: false,
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            initialized: (state) => state.whatsapp.info.initialized,
            status: (state) => state.whatsapp.info.status,
            whatsappPlan: (state) => state.site.currentPlans.find((cp) => cp.planType === "whatsapp"),
        }),
    },
    methods: {
        ...mapMutations({
            setWhatsappInfo: "whatsapp/setInfo",
        }),
        getStatus(order) {
            if (order < this.current) return "finish";
            if (order === this.current) return "process";
            return "wait";
        },
        fetchWhatsappStatus() {
            sendSocketMessage("user get-whatsapp-status", {
                siteId: this.site._id,
            });
        },
        goWhatsappPlans() {
            this.$router.push({
                path: `/billing/plans/whatsapp`,
            });
        },
        agree() {
            this.agreementAccepted = true;
            this.current = 1;
            localStorage.setItem("wp-agreement-accepted", "true");
            if (!this.whatsappPlan) this.goWhatsappPlans();
        },
        activationCompleted() {
            this.current = 3;
            console.log("activationCompleted worked", this.current);
        },
        purchaseCompleted() {
            this.current = 2;
        },
        reCalculateStep(newStatus) {
            newStatus = newStatus || this.status;
            const launchState = newStatus.status?.LAUNCH_STATE;
            const botState = newStatus.status?.STATE;
            log("reCalculateStep", { launchState, botState });
            const isCompleted = launchState === "READY" || botState === "CONNECTED";
            const isQRStep =
                botState !== "CONNECTED" &&
                [LSTATES.QR_CODE_GENERATING, LSTATES.QR_CODE_GENERATED, LSTATES.AUTHENTICATING].includes(launchState);
            log("reCalculateStep", {
                newStatus,
                isCompleted,
                isQRStep,
            });

            if (!newStatus.purchased) {
                if (localStorage.getItem("wp-agreement-accepted") === "true") {
                    this.current = 1;
                    if (!this.whatsappPlan) this.goWhatsappPlans();
                } else {
                    this.current = 0;
                }
            } else {
                this.agreementAccepted = true;

                if (isCompleted) {
                    this.current = 4;
                } else if (isQRStep) {
                    this.current = 3;
                } else {
                    this.current = 2;
                }
            }
        },
    },
    mounted() {
        log("mounted");
        this.fetchWhatsappStatus();
        if (!this.status.purchased) {
            if (localStorage.getItem("wp-agreement-accepted") === "true") {
                this.current = 1;
                this.agreementAccepted = true;
                if (!this.whatsappPlan) this.goWhatsappPlans();
            } else {
                this.current = 0;
            }
        }
        this.reCalculateStep();
        this.timerId = setInterval(() => {
            this.fetchWhatsappStatus();
        }, 3000);
    },
    beforeDestroy() {
        clearInterval(this.timerId);
    },
    watch: {
        status(newStatus) {
            log("newStatus changed", newStatus);
            this.reCalculateStep(newStatus);
        },
    },
};
</script>

<style scoped></style>
